import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { IGenericObject } from '@/shared';
import { handleApiError } from '@/shared/axios/helpers/errors';

export const baseRequest = {
  get: async (path: string, querystring: string = '', config?: AxiosRequestConfig) => {
    try {
      const response = await axios.get(`${path}${querystring}`, config);
      return response.data || response;
    } catch (err) {
      return handleApiError(err as AxiosError);
    }
  },
  post: async (path: string, data: IGenericObject, config?: AxiosRequestConfig) => {
    try {
      const response = await axios.post(path, data, config);
      return response.data || response;
    } catch (err) {
      return handleApiError(err as AxiosError);
    }
  },
  put: async (path: string, data: IGenericObject, config?: AxiosRequestConfig) => {
    try {
      const response = await axios.put(path, data, config);
      return response.data || response;
    } catch (err) {
      return handleApiError(err as AxiosError);
    }
  },
  patch: async (path: string, data: IGenericObject, config?: AxiosRequestConfig) => {
    try {
      const response = await axios.patch(path, data, config);
      return response.data || response;
    } catch (err) {
      return handleApiError(err as AxiosError);
    }
  },
  delete: async <IExpectedResponseType>(path: string, config?: AxiosRequestConfig): Promise<IExpectedResponseType> => {
    try {
      const response = await axios.delete(path, config);
      return response.data || null;
    } catch (err) {
      return handleApiError(err as AxiosError);
    }
  },

};
